import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const TimespaceContext = createContext<{
  params?: Routing.TimespaceParams
}>({})

export { TimespaceContext }
